import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import persistConfig from "./persistConfig";
import errorMiddleware from "./middleware/errorMiddleware";
import loggerMiddleware from "./middleware/loggerMiddleware";

// Import reducers
import projectReducer from "./slices/projectSlice";
import projectObjectiveReducer from "./slices/projectObjectiveSlice";
import navigationReducer from "./slices/navigationSlice";
import qualificationReducer from "./slices/qualificationSlice";
import qualificationStepReducer from "./slices/qualificationStepSlice";
import pageReducer from "./slices/pageSlice";
import componentReducer from "./slices/componentSlice";

// Combine reducers
const rootReducer = {
  project: projectReducer,
  projectObjective: projectObjectiveReducer,
  navigation: navigationReducer,
  qualification: qualificationReducer,
  qualificationStep: qualificationStepReducer,
  page: pageReducer,
  component: componentReducer,
};

// Apply redux-persist
const persistedReducer = persistReducer(persistConfig, (state = {}, action) => {
  const newState = {};
  Object.keys(rootReducer).forEach((key) => {
    newState[key] = rootReducer[key](state[key], action);
  });
  return newState;
});

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(errorMiddleware)
      .concat(loggerMiddleware),
  devTools: process.env.NODE_ENV !== "production",
});

// Create persistor
export const persistor = persistStore(store);

export default store;
